import Avatar from '@mui/material/Avatar';
import Link from '@mui/material/Link';
import { useTranslation } from 'react-i18next';

import TicketCard from 'src/common/components/styled/TicketCard';
import TicketCardEditDeleteFooter from 'src/common/components/styled/TicketCardEditDeleteFooter';
import { ISponsor } from 'src/interfaces/Sponsor';

interface SponsorsManagerCardProps {
  sponsor: ISponsor;
  onEdit: (sponsor: ISponsor) => void;
  onDelete: (id: string) => void;
}

const SponsorsManagerCard = ({ sponsor, onEdit, onDelete }: SponsorsManagerCardProps) => {
  const { t } = useTranslation();

  return (
    <TicketCard
      eyebrow={t('drawer.sponsors')}
      title={sponsor.name}
      description={
        sponsor.url ? (
          <Link
            href={sponsor.url}
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            color="inherit"
            sx={{ wordBreak: 'break-all' }}
          >
            {sponsor.url}
          </Link>
        ) : (
          '-'
        )
      }
      avatar={
        <Avatar
          src={sponsor.imageUrl || undefined}
          variant="rounded"
          sx={{ bgcolor: 'grey.200', borderRadius: '50%' }}
        >
          {!sponsor.imageUrl ? sponsor.name.charAt(0) : null}
        </Avatar>
      }
      footer={
        <TicketCardEditDeleteFooter
          popupId={`sponsor-tools-${sponsor.id}`}
          optionsAriaLabel={t('technicalTypes.optionsLabel')}
          editLabel={t('participants.edit')}
          deleteLabel={t('participants.delete')}
          onEdit={() => onEdit(sponsor)}
          onDelete={() => onDelete(sponsor.id)}
        />
      }
      badges={[
        ...(sponsor.isOrganizer
          ? [{ label: t('system.sponsors.organizer'), highlighted: true as const }]
          : []),
        {
          label:
            sponsor.published !== false
              ? t('system.sponsors.published')
              : t('system.sponsors.unpublished'),
          highlighted: sponsor.published !== false,
        },
      ]}
    />
  );
};

export default SponsorsManagerCard;
